"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateResponse = validateResponse;
var _fetching = require("@ori/fetching");
// TODO use zod/mini when available

// Type overload for when the response data is validated by a schema

// Type overload for when the response data is not validated by a schema

function validateResponse(response, {
  successStatus = _fetching.STATUS_OK,
  onError,
  onSuccess,
  schema
}) {
  if (response.status !== successStatus) {
    const {
      data,
      ...responseWithoutData
    } = response;
    return onError(responseWithoutData);
  }
  if (schema) {
    const parseResult = schema.safeParse(response.data);
    if (!parseResult.success) {
      const {
        data,
        ...responseWithoutData
      } = response;
      return onError(responseWithoutData);
    }
    const validatedResponse = {
      ...response,
      data: parseResult.data
    };
    return onSuccess(validatedResponse);
  }
  return onSuccess(response);
}
